export default __webpack_public_path__ + "static/media/Ziggys.d6ff0521.jpg";